// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconAlert = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M12 18c-.62 0-1.12-.5-1.12-1.12 0-.62.5-1.12 1.12-1.12.62 0 1.12.5 1.12 1.12 0 .62-.5 1.12-1.12 1.12zm.75-4.5V5.25c0-.41-.34-.75-.75-.75s-.75.34-.75.75v8.25a.749.749 0 101.5 0zM12 24C5.38 24 0 18.62 0 12S5.38 0 12 0s12 5.38 12 12-5.39 12-12 12zm0-22.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.78 1.5 12 1.5z"
      fill="currentColor"
    />
  );
export default SvgIconAlert;
